import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import VueMeta from "vue-meta";

Vue.use(VueMeta);

import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

import { MediaQuery } from "./helpers/mediaqueryModel";

import clearUrl from "./filters/urlcleaner";
Vue.filter("clearUrl", clearUrl);

import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

const requireComponent = require.context(
	// The relative path of the components folder
	"./components/modules",
	// Whether or not to look in subfolders
	false,
	// The regular expression used to match base component filenames
	/Module[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
	// Get component config
	const componentConfig = requireComponent(fileName);

	// Get PascalCase name of component
	const componentName = upperFirst(
		camelCase(
			// Gets the file name regardless of folder depth
			fileName
				.split("/")
				.pop()
				.replace(/\.\w+$/, "")
		)
	);

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	);
});

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	created() {
		// TODO - would be cool to move this functionality to renderless component
		const mq = new MediaQuery();
		Vue.prototype.$mq = mq;
	},
	render: (h) => h(App),
}).$mount("#app");
